<template>
  <div class="download" >
    <p class="content">We improve your mobile signals  and more.</p>
    <!-- 下载安卓 -->
    <div class="download_btn android" @click="downLoadApp(0)">
      <img src="/static/img/android.png" alt="">
      <span>Android Download</span>
    </div>
    <div class="download_btn ios" @click="downLoadApp(1)">
      <img src="/static/img/ios.png" alt="">
      <span>IOS Download</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        
      }
    },
    methods: {
      downLoadApp (type) {
        let u = navigator.userAgent
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        // type: 1为IOS 0为安卓
        if (type === 0 && isAndroid) {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.signalsupervisor.boosterus'
        } else if (type ===1 && isIOS) {
          window.location.href = 'https://itunes.apple.com/cn/app/id1280317267?mt=8'
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.download{
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url('/static/img/download.png');
  background-position: top;
  background-size: cover;
  .content{
    position: absolute;
    top: 385px;
    left: 48px;
    right: 48px;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    font-family: PingFang TC;
    text-align: center;
  }
  .download_btn{
    position: absolute;
    bottom: 147px;
    width:202px;
    height: 50px;
    border-radius: 10px;
    left: 50%;
    margin-left: -101px;
    font-size: 15px;
    font-family: PingFang TC;
    font-weight: 500;
    color: #fff;
    display: flex;
    align-items: center;
    // justify-content: center;
    background: #00C8CA;
    img{
      display: inline-block;
      width: 30px;
      height: auto;
      margin:0 11px 0 17px;
    }
  }
  .ios{
    bottom: 63px;
    background: #061721;
  }
}
</style>